"use client";

import useLoginModal from "../hooks/useLoginModal";
import { useAuthStore } from "../hooks/auth";
import { useState } from "react";
import toast from "react-hot-toast";

type BuyAlbumButtonProps = {
  startCheckout: (formData: FormData) => Promise<void> | void; // 🔥 TIPAGEM CORRETA
  userId?: string | number | null; // 🔥 RECEBE USERID SSR
  label?: string;
  className?: string;
  disabled?: boolean;
};

export default function BuyAlbumButton({
  startCheckout,
  userId,
  label = "Comprar álbum",
  className = "",
  disabled,
}: BuyAlbumButtonProps) {
  const login = useLoginModal();
  const user = useAuthStore((s) => s.user);
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    if (disabled || loading) return;

    if (!userId) {
      console.log("🟡 Usuário não logado → abrindo LoginModal");
      login.open();
      return;
  }

     try {
      setLoading(true);
      const fd = new FormData();
      await startCheckout(fd);
    } catch (err: any) {
      console.error("Erro ao iniciar checkout:", err);
      const msg = err?.message || "";

      if (msg === "AUTH_FORBIDDEN") {
      console.log("🔴 Sessão inválida/expirada → abrindo LoginModal");
      login.open();
      toast.error("Sessão expirada. Clique em sair e entre novamente.");
      return;
     }

    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      disabled={disabled || loading}
      onClick={handleClick}
      className={
        className ||
        "rounded-2xl px-6 py-3 bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
      }
    >
      {loading ? "Processando..." : label}
    </button>
  );
}
